const Icon = ({ component: Component, size = 24, color = 'currentColor', ...props }) => {
  return Component ? (
    <Component width={size} height={size} fill={color} {...props} />
  ) : null;
};

export default Icon;